import { Box } from '@mui/material';

import { borderRadius } from '@verantos-dev/shared-ui-components/tokens';

import type { SubtleSurfaceProps } from '../types';

// TODO: no VDS token for #F5F5F5 — needs designer input (matches cohort).
const SUBTLE_BG = '#F5F5F5';

export const SubtleSurface = ({
  children,
  sx,
  'data-testid': dataTestId,
  onClick,
  onKeyDown,
  role,
  tabIndex,
  'aria-label': ariaLabel,
}: SubtleSurfaceProps) => (
  <Box
    data-testid={dataTestId}
    onClick={onClick}
    onKeyDown={onKeyDown}
    role={role}
    tabIndex={tabIndex}
    aria-label={ariaLabel}
    sx={[
      { backgroundColor: SUBTLE_BG, borderRadius: `${borderRadius.md}px` },
      ...(Array.isArray(sx) ? sx : [sx]),
    ]}
  >
    {children}
  </Box>
);
